import React, { useMemo } from 'react';
import { OriginValuePopover } from './OriginValuePopover';

//! deprecated
// import { useCompareOverlayAndOriginValue, useOverlayValue } from './hooks';

const OverlayValueItem = (props) => {
  const {
    noWrapper,
    children,
    noHighlight = false,
    showOverlay = true,
    checkShowOverlayFn,
    originValue,
    originValueRenderFn,
    hightlightStyle,
  } = props;

  const isShowOverlay = checkShowOverlayFn ? checkShowOverlayFn() : showOverlay;

  if (!isShowOverlay) {
    return <>{children && children}</>;
  }

  const originValueRender = originValueRenderFn
    ? originValueRenderFn()
    : originValue;

  const valueWrapperProps = {
    noHighlight,
    hightlightStyle,
    originValueRender,
  };

  return noWrapper ? (
    <>{children && children}</>
  ) : (
    <ValueWrapper {...valueWrapperProps}>{children && children}</ValueWrapper>
  );
};

const ValueWrapper = ({
  children,
  noHighlight,
  hightlightStyle,
  originValueRender,
}) => {
  return (
    <OriginValuePopover
      originValueRender={originValueRender}
      showHighLight={!noHighlight}
      hightlightStyle={hightlightStyle}
    >
      {children && children}
    </OriginValuePopover>
  );
};

export default OverlayValueItem;
